// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"460":"9547b355","710":"7d15800b","924":"5450f74e"}[chunkId] + ".chunk.js";
};